<template>
  <div class="border">
    <h5 class="mb-2">
      {{ "send_request_to_syste" | setText("Отправить запрос в систему") }}
    </h5>
    <button class="btn btn-info btn-icon mw" @click="sendRequest">
      {{ "create_query" | setText("Сформировать заявку") }}
    </button>
  </div>
</template>
<script>
import { logger, errorNotify, toFormData } from "@/plugins/functions";

//https://api.mobile.com.kz/api/Certificates/Return
//?certificateId=1414404000048&series=UC

export default {
  methods: {
    async sendRequest() {
      this.$loading(true);
      const action = "Certificates/sale";
      const url = this.data.service.api_endpoint_url + action;
      const token = this.data.service.api_token;
      const method = "post";

      try {
        const check = await this.$http.get(`certificates/${this.data["id"]}`);
        if (check.data.data.exchange_id && check.data.data.state === "sent") {
          this.$emit("input", {
            state: "sent",
            is_paid: 1,
          });
          return false;
        }
      } catch (error) {
        // alert('Ошибка отправки запроса. Пожалуйста, создайте новую заявку')
      }

      logger(this.$http, {
        name: "Запрос в Keeptok",
        url: url,
      });

      let data = {
        NumberCertificate: "0", 
        CostCertificate: this.data.price_partner,
        DateCertificate: this.data.created_at,
        FirstNameManager: this.data.user.name,
        LastNameManager: "Интеграция Smartblax",
        CostProduct: this.data.price_variant,
        ManagerPhone: this.data.user.phone,
        ContactBuyer: this.data.client.phone,
        DeviceBrand:
          this.data.variant.product && this.data.variant.product.brand
            ? this.data.variant.product.brand.name
            : "",
        FirstNameBuyer: this.data.client.first_name,
        LastNameBuyer: this.data.client.last_name,
        Shop_id: "22",
        ShopBranch_id: this.data.shop_id,
        DeviceModel: this.data.name,
        DeviceIMEI: this.data.code,
        Series: "UC",
        //CustomerPINFL
        // EmailBuyer: this.data.client.email,
        CustomerPINFL: this.data.client.PINFL,
      };

      if (this.data.user.email) {
        data["ManagerEMail"] = this.data.user.email;
      }

      return this.$http({
        method: method,
        //data: toFormData(data),
        data: data,
        url: url,
        headers: {
          "X-Access-Token": `${token}`,
          "Content-Type": `application/json`,
        },
      })
        .then((response) => {
          const data = response.data;
          if (data && data.NumberCertificate) {
            this.$emit("input", {
              state: "sent",
              status: "done",
              is_paid: 1,
              response: JSON.stringify(data),
              exchange_id: data.NumberCertificate,
            });
            this.$store.dispatch("setLastUpdate", new Date());
          } else {
            alert("Неизвестная ошибка");
            this.$loading(false);
          }

          return response.data;
        })
        .catch((error) => {
          this.$loading(false);
          return errorNotify(error, this.notify);
        })
        .finally(() => {});
    },
  },
  data: () => ({}),
  props: ["value", "data"],
};
</script>
<style>
</style>
 